import React from 'react'
import Collection from './collection'
import Country from './Country'
import Ottplatformlink from './Ottplatformlink'
import Poster from './poster'
import Releasedate from './Releasedate'
import Restrict from './restrict'
import Wikilink from './Wikilink'
import { Col, Row } from 'react-bootstrap'
import MovieBadget from './Budget'
import MovieImdb from './Imdb'
import RunTime from './Runtime'
import MovieYouSayRating from './MovieYouSayRating'
import NoofSeasonsandEpisodes from './NoofSeasonsandEpisodes'
import TfidbTags from './TfidbTags'
import AdminTags from './AdminTags'

const renderCheckbox = (label, checked, onChange) => (
  <Col md={6} xs={12}>
    <div className='tinput'>
      <div
        className='currentlyactive-style'
        style={{ display: 'flex', gap: '10px', position: 'relative', top: '30px' }}
      >
        <input
          type='checkbox'
          id={label.toLowerCase()}
          name={label.toLowerCase()}
          checked={checked}
          onChange={onChange}
        />
        <label htmlFor={label.toLowerCase()}>ok</label>
      </div>
    </div>
  </Col>
)

const English = props => {
  // props to this file from parent
  const {
    movieData,
    movieMode,
    inputData,
    updateInputData,
    modeUrl,
    handleActiveChange,
    active,
    editData,
    sendinputdata,
    sendBooleanValueChangeDone,
    mode,
  } = props
  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <Releasedate
            inputData={inputData}
            sendinputdata={sendinputdata}
            modeUrl={modeUrl}
            sendBooleanValueChangeDone={sendBooleanValueChangeDone}
            active={active}
            editData={editData}
            releaseDate={inputData.releaseDate}
            noReleaseDate={inputData.releaseDateUi}
            sendReleseDate={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
          />
        </Col>
        {modeUrl &&
          renderCheckbox('Release Date', active.releasedate === 'TRUE', event =>
            handleActiveChange(event, 'releasedate'),
          )}
      </Row>
      <Restrict
        restrit={inputData.restrit}
        inputData={inputData}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        sendrestrit={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
      />
      <Row>
        {
          <Col md={10} xs={12}>
            <Wikilink
              modeUrl={modeUrl}
              active={active}
              editData={editData}
              sendBooleanValueChangeDone={sendBooleanValueChangeDone}
              wikilink={inputData.wikilink}
              sendwikilink={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
            />
          </Col>
        }
        {modeUrl && (
          <Col md={2} xs={12}>
            <div className='tinput'>
              <div
                className='currentlyactive-style'
                style={{ display: 'flex', gap: '10px', position: 'relative', top: '30px' }}
              >
                <input
                  id='wikipedia'
                  type='checkbox'
                  name='currently active'
                  checked={active.wikipedia === 'TRUE'}
                  onChange={event => handleActiveChange(event, 'wikipedia')}
                />
                <label htmlFor='wikipedia'>OK</label>
                <br></br>
              </div>
            </div>
          </Col>
        )}
      </Row>
      <Ottplatformlink
        // mode={mode}
        inputData={inputData}
        sendinputdata={sendinputdata}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        Movielinks={inputData.Movielinks}
        sendlinks={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
        ott={inputData.ott}
        sendott={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
      />
      <Row>
        <Col md={6} xs={12}>
          <RunTime
            modeUrl={modeUrl}
            active={active}
            editData={editData}
            sendBooleanValueChangeDone={sendBooleanValueChangeDone}
            runTime={inputData.runTime}
            sendRunTime={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
          />
        </Col>
        {modeUrl &&
          renderCheckbox('runTime', active.runtime === 'TRUE', event =>
            handleActiveChange(event, 'runtime'),
          )}
      </Row>
      <Row>
        <Col md={6} xs={12}>
          <Country
            modeUrl={modeUrl}
            active={active}
            editData={editData}
            sendBooleanValueChangeDone={sendBooleanValueChangeDone}
            country={inputData.country}
            sendcountry={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
          />
        </Col>
        {modeUrl &&
          renderCheckbox('country', active.country === 'TRUE', event =>
            handleActiveChange(event, 'country'),
          )}
      </Row>
      <Row>
        <Col md={6} xs={12}>
          <MovieBadget
            modeUrl={modeUrl}
            active={active}
            editData={editData}
            sendBooleanValueChangeDone={sendBooleanValueChangeDone}
            Budget={inputData.Budget}
            sendBudget={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
          />
        </Col>
        {modeUrl &&
          renderCheckbox('MovieBadget', active.Budget === 'TRUE', event =>
            handleActiveChange(event, 'Budget'),
          )}
      </Row>
      <Row>
        <Col md={6} xs={12}>
          <Collection
            modeUrl={modeUrl}
            active={active}
            editData={editData}
            sendBooleanValueChangeDone={sendBooleanValueChangeDone}
            collection={inputData.collection}
            sendcollection={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
          />
        </Col>
        {modeUrl &&
          renderCheckbox('Collection', active.collection === 'TRUE', event =>
            handleActiveChange(event, 'collection'),
          )}
      </Row>
      <MovieImdb
        movieMode={movieMode}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        Imdb={inputData.imdb}
        MovieYouSayRatingInput={inputData.MovieYouSayRating}
        sendImdb={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
      />
      <MovieYouSayRating
        MovieYouSayRatingInput={inputData.MovieYouSayRating}
        inputData={inputData}
        sendinputdata={sendinputdata}
        // MovieYouSayReviewUrl={inputData.MovieYouSayReviewUrl}
        // MovieYouSayReviewUrlTe={inputData.MovieYouSayReviewUrlTe}
        // movieReviewArticleTitleEn={inputData.movieReviewArticleTitleEn}
        // movieReviewArticleTitleTe={inputData.movieReviewArticleTitleTe}
        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
        sendYousayRating={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
        Imdb={inputData.imdb}
      />
      {inputData.contentType === 'webseries' && (
        <NoofSeasonsandEpisodes
          inputData={inputData}
          sendBooleanValueChangeDone={sendBooleanValueChangeDone}
          sendNoofEpisodes={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
        />
      )}
      <Row>
        <Col md={8} xs={12}>
          <Poster
            modeUrl={modeUrl}
            poster={inputData.poster}
            active={active}
            editData={editData}
            sendBooleanValueChangeDone={sendBooleanValueChangeDone}
            sendPosterUrl={(fieldName, fieldValue) => updateInputData(fieldName, fieldValue)}
          />
        </Col>
        {modeUrl && (
          <Col md={4} xs={12}>
            <div className='tinput'>
              <div
                className='currentlyactive-style'
                style={{ display: 'flex', gap: '10px', position: 'relative', top: '30px' }}
              >
                <input
                  id='Poster'
                  type='checkbox'
                  name='currently active'
                  checked={active.poster === 'TRUE'}
                  onChange={event => handleActiveChange(event, 'poster')}
                />
                <label htmlFor='Poster'>OK</label>
                <br></br>
              </div>
            </div>
          </Col>
        )}
      </Row>
      {mode === 'edit' && <TfidbTags movieData={movieData} />}
      {mode === 'edit' && <AdminTags movieData={movieData} label={'Good'} />}
      {mode === 'edit' && <AdminTags movieData={movieData} label={'Bad'} />}
    </div>
  )
}

export default English
